import styles from './modal-header.module.scss';
export const ModalHeader = ({ label, onClose, className }) => {
  return (
    <header className={`${styles['header-container']} ${className}`}>
      <p>{label}</p>
      <span onClick={onClose}>X</span>
    </header>
  );
};
